import { useCallback, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { LandingPageSectionsContainer } from "@containers/verification-service-details/verification-service-details-tab-container/verification-service-details-theming-tab/theming-landing-page-tab-container/landing-page-sections-container/landing-page-sections-container";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { PageLevelTypes } from "@enums/page-level-types";
import { RedirectUrlInformation } from "@idw-types/redirect-url-information";
import Alert from "react-bootstrap/Alert";
import { resources } from "@constants/hardcoded-strings";
import { RedirectUrlOriginTypes } from "@enums/redirect-url-origin-types";

type VerificationServiceRedirectUrlContainerProps = {
    isDisabled: boolean;
    isBelongToWorkflow: boolean;
    pageLevel: PageLevelTypes;
    redirectUrlsInformation: RedirectUrlInformation;
    redirectUrlError: React.ReactNode;
    handleRemoveRedirect: (index: number, redirectUrlOrigin: RedirectUrlOriginTypes) => void;
    handleAddRedirect: (newRedirectUrl: string) => void;
    handleRedirectChangeAtIndex: (newRedirectUrl: string, index: number, redirectUrl: string, redirectUrlOrigin: RedirectUrlOriginTypes) => void;
}

export const VerificationServiceRedirectUrlContainer = (props: VerificationServiceRedirectUrlContainerProps) => {
    const {
        isDisabled,
        pageLevel,
        redirectUrlsInformation,
        isBelongToWorkflow,
        redirectUrlError,
        handleAddRedirect,
        handleRemoveRedirect,
        handleRedirectChangeAtIndex
    } = props;

    const [showOriginBadge, setShowOriginBadge] = useState(false);

    const handleHotKeyPressed = useCallback(() => {
        setShowOriginBadge(prevShowOriginBadge => !prevShowOriginBadge)
    }, [showOriginBadge]);

    useHotkeys("ctrl+shift+u, command+shift+u", handleHotKeyPressed);

    return (
        <div>
            <ContentPageHeader title={"Redirect URLs"} />
            <ContentPageBody isMaxWidth={true}>
                {isBelongToWorkflow && <Alert variant={"warning"}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.basicInfo.inputs.redirectUrls.serviceBelongToWorkflowWarningMessage}</Alert>}
                    <>
                        {redirectUrlError}
                        <LandingPageSectionsContainer
                            isDisabled={isDisabled || isBelongToWorkflow}
                            isTheming={false}
                            showOriginBadge={showOriginBadge}
                            validationErrors={null}
                            axnuiContent={null}
                            axnuiLayout={null}
                            inheritedAXNUIContent={null}
                            inheritedAXNUILayout={null}
                            pageLevel={pageLevel}
                            redirectUrlsInformation={redirectUrlsInformation}
                            handleRemoveRedirect={handleRemoveRedirect}
                            handleAddRedirect={handleAddRedirect}
                            handleRedirectChangeAtIndex={handleRedirectChangeAtIndex}
                            updateAXNUIContentPropertyValue={() => { }}
                            updateAXNUILayoutPropertyValue={() => { }}
                        />
                    </>
            </ContentPageBody>
        </div>
    )

}